import { EmailInput, type EmailInputProps } from "@common/controls/Inputs/Text";

export { type EmailInputProps };
export default EmailInput;
